import { render, staticRenderFns } from "./CustomAppendText.vue?vue&type=template&id=678a1192"
import script from "./CustomAppendText.vue?vue&type=script&lang=js"
export * from "./CustomAppendText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports